import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './client';
// Get a single match with full detail
export function useGetMatch(matchId) {
    return useQuery({
        queryKey: ['matches', matchId],
        queryFn: () => api.request(`/api/matches/${matchId}`),
        enabled: matchId > 0,
    });
}
// Apply a match result (sets winner + score)
export function useApplyMatchResult() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ matchId, body, }) => api.request(`/api/matches/${matchId}/result`, {
            method: 'POST',
            body: JSON.stringify(body),
        }),
        onSuccess: (_data, { matchId }) => {
            void qc.invalidateQueries({ queryKey: ['matches', matchId] });
            void qc.invalidateQueries({ queryKey: ['rounds'] });
        },
    });
}
// Revert a match result back to scheduled
export function useRevertMatchResult() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (matchId) => api.request(`/api/matches/${matchId}/revert`, {
            method: 'POST',
        }),
        onSuccess: (_data, matchId) => {
            void qc.invalidateQueries({ queryKey: ['matches', matchId] });
            void qc.invalidateQueries({ queryKey: ['rounds'] });
        },
    });
}
// Mark a match as walkover (one player wins by default)
export function useMarkWalkover() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ matchId, body, }) => api.request(`/api/matches/${matchId}/walkover`, {
            method: 'POST',
            body: JSON.stringify(body),
        }),
        onSuccess: (_data, { matchId }) => {
            void qc.invalidateQueries({ queryKey: ['matches', matchId] });
            void qc.invalidateQueries({ queryKey: ['rounds'] });
        },
    });
}
// Mark a match as admin draw
export function useMarkAdminDraw() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (matchId) => api.request(`/api/matches/${matchId}/admin_draw`, {
            method: 'POST',
        }),
        onSuccess: (_data, matchId) => {
            void qc.invalidateQueries({ queryKey: ['matches', matchId] });
            void qc.invalidateQueries({ queryKey: ['rounds'] });
        },
    });
}
// Mark a match as bye (single player, no opponent)
export function useMarkBye() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (matchId) => api.request(`/api/matches/${matchId}/bye`, {
            method: 'POST',
        }),
        onSuccess: (_data, matchId) => {
            void qc.invalidateQueries({ queryKey: ['matches', matchId] });
            void qc.invalidateQueries({ queryKey: ['rounds'] });
        },
    });
}
